export default "__VITE_ASSET__DzsjQef9__"